import { getRawClaim } from './getValueFromToken';
import { hideBookAccess } from './hideBookAccess';

/**
 * Whether the Books section is shown in the DMP. Uses the `showBooks` claim
 * when the token carries it; older tokens, impersonation and tokens minted
 * with the DS claims read off fall back to the legacy `hideBooks` rule.
 */
export const showBooks = () => {
  const claim = getRawClaim('showBooks');
  return typeof claim === 'boolean' ? claim : !hideBookAccess();
};
